import { useEffect, useState } from 'react'
import { mockProposal } from '../../../data/mockProposal'
import { Navbar } from '../../../components/layout/Navbar'
import { useNavigate } from 'react-router-dom'
import PendingProposalsContent from './pendingProposals/PendingProposalsContent'
import ProposalAdjustmentsContent from './proposalAdjustments/ProposalAdjustmentsContent'
import NewLeaseQuoteContent from './newLeaseQuote/NewLeaseQuoteContent'
import RejectedProposalContent from './rejectedProposal/RejectedProposalContent'
import { ProposalQuoteOption, ProposalReviewView } from '@/types'

export const ProposalReviewPageContent = () => {
  const [proposalData, setProposalData] = useState<ProposalQuoteOption[]>([])
  const [selectedProposal, setSelectedProposal] =
    useState<ProposalQuoteOption | null>(null)
  const [view, setView] = useState<ProposalReviewView>('pending')

  const navigate = useNavigate()
  console.log('update')

  const getProposal = () => {
    setProposalData(mockProposal)
  }

  useEffect(() => {
    getProposal()
  }, [])

  if (!proposalData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg text-gray-600">Cargando propuesta...</div>
      </div>
    )
  }

  return (
    <>
      {/* Mobile Layout */}
      <div className="min-h-screen flex flex-col md:hidden">
        {/* Mobile Header - Solo gradiente */}
        <div
          className="h-48 flex items-center justify-center relative"
          style={{
            background:
              'linear-gradient(180deg, #1789CF 0%, #02298A 84.79%, #021B79 100%)',
            minHeight: '192px',
          }}
        >
          {/* Logo centrado - más grande */}
          <div className="text-center z-10">
            <img
              src="/assets/olr-logo.png"
              alt="OLR Leasing"
              className="filter brightness-0 invert w-40 h-auto mx-auto"
            />
          </div>
        </div>

        {/* Mobile Form section - menos padding top */}
        <div className="flex-1 bg-white flex items-start justify-center pt-8 px-6 pb-6">
          <div className="w-full max-w-md">
            <h2 className="text-2xl font-bold text-gray-900 mb-2 text-center">
              Tu cotización está lista
            </h2>

            <p className="text-gray-600 justify-center text-center wordwrap mb-6">
              Hemos revisado tu información y generado una propuesta con las
              condiciones de arrendamiento. Por favor, revísala cuidadosamente y
              elige cómo deseas continuar.
            </p>
            <div className="w-full max-w-6xl p-8 ">
              {/* Aquí va el contenido de la página */}
            </div>
            <div className="w-full max-w-6xl p-8 ">
              {/* Aquí va el contenido de la página */}
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden md:flex min-h-screen flex-col">
        <Navbar />

        {/* Main content with bg-flow */}
        <div
          className="flex-1 flex flex-col items-center justify-start p-4"
          style={{
            backgroundImage: 'url(/assets/bg-flow.svg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          {view === 'pending' && (
            <PendingProposalsContent
              proposals={proposalData}
              setSelectedProposal={setSelectedProposal}
              setView={setView}
            />
          )}
          {view === 'adjustments' && (
            <ProposalAdjustmentsContent
              proposal={selectedProposal}
              setView={setView}
            />
          )}
          {view === 'rejected' && <RejectedProposalContent setView={setView} />}
          {view === 'new' && (
            <NewLeaseQuoteContent
              pdfUrl="https://test-olr.s3.us-east-2.amazonaws.com/f17c798f-21f6-427f-a7f1-185b44c8cbbc/Arrendamiento/f17c798f-21f6-427f-a7f1-185b44c8cbbc-leasing-contract-yscgkc11bhn.pdf"
              onGoBack={() => console.log('Going back')}
              onConfirmAndContinue={() => {
                console.log('Confirming and continuing')
                navigate('/initial-payment')
              }}
            />
          )}
        </div>
      </div>
    </>
  )
}
